<template>
  <div class="loading-container">
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
    <p v-if="showText" class="loading-text">{{ message }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  message: {
    type: String,
    default: 'Loading...'
  },
  showText: {
    type: Boolean,
    default: true
  }
});
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  height: 100%;
  background-color: var(--color-background);
  min-height: 200px;
}

.loading-text {
  margin-top: 1rem;
  color: var(--color-text-dark);
  font-size: 1rem;
  animation: pulse 1.5s infinite;
}

.spinner {
  display: flex;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.spinner>div {
  width: 18px;
  height: 18px;
  background-color: var(--color-primary);
  border-radius: 100%;
  display: inline-block;
  margin: 0 3px;
  animation: bounce 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.0);
  }
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}
</style>
